import React, { createContext, useContext, useState, useCallback } from 'react';
import fr from '../i18n/fr';
import en from '../i18n/en';

const TRANSLATIONS = { fr, en };
const STORAGE_KEY  = 'carrent_lang';

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'fr') return saved;
    // Auto-detect browser language
    const browser = navigator.language?.slice(0, 2);
    return browser === 'en' ? 'en' : 'fr';
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
    document.documentElement.lang = l;
  }, []);

  const toggleLang = useCallback(() => {
    setLang(lang === 'fr' ? 'en' : 'fr');
  }, [lang, setLang]);

  const t = TRANSLATIONS[lang];

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside <LangProvider>');
  return ctx;
}
